// UpdatePrompts.jsx
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { apiGet, apiPost } from "api/callApi";
import { Breadcrumbs } from "InnoUI/components";
import { Button } from "InnoUI/components";
import theme from "theme";
import SC from "./style";

// Replace these imports with the real components in your repo:
import { TextInput } from "@InnoInput/"; // you used this earlier
import { showAlert } from "utils/helper";

const UpdatePrompts = ({ popupState }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { newData } = location.state || {};

  const [title, setTitle] = useState(newData?.title || "");
  const [body, setBody] = useState(""); // prompt body as plain text
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // breadcrumb
  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "System Prompts", href: "/admin-settings/system-prompts" },
    { label: `${newData?.title || ""}`, href: null },
  ];

  const getSinglePrompt = async () => {
    if (!newData?.id) return;
    try {
      setIsLoading(true);
      const response = await apiGet(`/v1/getprompt/${newData.id}`, false);
      // adapt if your helper wraps response differently
      const d = response?.data || response;
      const currentPrompt =
        d?.current_prompt ?? d?.current_prompt ?? d?.prompt ?? "";
      const promptTitle =
        d?.current_prompt ?? d?.current_prompt ?? newData?.title ?? "";
      setTitle(promptTitle);
      setBody(currentPrompt);
    } catch (err) {
      console.error("getSinglePrompt error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSinglePrompt();
  }, [newData?.id]);

  const onClose = () => {
    navigate(-1);
  };

  const handleSubmit = async () => {
    if (!newData?.id) {
      alert("Missing prompt id");
      return;
    }
    try {
      setIsSaving(true);
      const payload = {
        prompt: body || "",
      };
      const res = await apiPost(
        `/v1/updateprompt/${newData.id}`,
        payload,
        false
      );
      const ok =
        (res?.data &&
          (res.data.status === "success" || res.data.status === 200)) ||
        res?.status === 200 ||
        res?.status === "success";

      if (ok) {
        navigate(-1);
        await getSinglePrompt();
      } else {
        console.error("Update failed:", res);
        showAlert({ title: "Warning", text: res?.message, icon: "warning" });
      }
    } catch (err) {
      showAlert({
        title: "Error",
        text: "Failed to update prompt",
        icon: "error",
      });
      console.error("handleSubmit error:", err);
    } finally {
      setIsSaving(false);
    }
  };

  const handleChange = (field, value) => {
    console.log(field, value, "hj");
    if (field === "title") setTitle(value);
    else if (field === "prompts") setBody(value);
  };

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={location.pathname}
        onClick={(href) => href && navigate(href)}
      />

      {isLoading ? (
        <div style={{ padding: 20 }}>Skelton...</div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              padding: 16,
              marginTop: 50,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h3 style={{ marginBottom: 12 }}>
              {newData?.title || "Edit Prompt"}
            </h3>

            <div
              style={{
                position: "sticky",
                bottom: 0,
                zIndex: 30,
                background: "#fff",
                padding: 12,
                display: "flex",
                justifyContent: "flex-end",
                gap: 12,
              }}
            >
              <Button
                caption="Close"
                onClick={onClose}
                fontSize="12px"
                style={{
                  minWidth: 100,
                  height: 36,
                  background: theme.colors?.cancelButton,
                  color: theme.colors?.white,
                }}
              />

              <Button
                caption={isSaving ? "Saving..." : "Save"}
                onClick={handleSubmit}
                fontSize="12px"
                color="white"
                disabled={isSaving}
                style={{
                  minWidth: 140,
                  height: 36,
                  background: theme.gradient?.themeGradient,
                  color: theme.colors?.white,
                }}
              />
            </div>
          </div>

          <SC.BodyContainer>
            <TextInput
              defaultValue={title}
              onChange={(value) => handleChange("prompts", value)}
              name="title"
              label="Prompt Title"
              isTextArea={true}
              style={{ marginBottom: 16, minHeight: 500 }}
              maxLength={50000}
            />
          </SC.BodyContainer>
        </>
      )}
    </>
  );
};

export default UpdatePrompts;
